import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";
import Pagination from "../../shared/pagination";

const ViewStock = () => {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sizeData, setSizeData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [supplierId, setSupplierId] = useState(null);
  const [sizeId, setSizeId] = useState(null);

  const getProducts = () => {
    setLoading(true);
    axios
      .post(API_URL.PRODUCT_SUPPLIER, {
        supplier_id: supplierId ? supplierId.value : null,
        size_id: sizeId ? sizeId.value : null
      })
      .then(
        (res) => {
          if (res.data.status === 1) {
            setProductData(res.data.data);
          }
          setIsLoaded(false);
          setLoading(false);
        },
        () => {
          setLoading(false);
          toast.error("Something went wrong..", { autoClose: 3000 });
        }
      );
  };

  const getSizeData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSizeData(cd);
    });
  };
  
  const getSuppliers = () => {
    axios.post(API_URL.PARTY_LIST, {is_seller: [1]}).then((res) => {
      let cd = res.data.data.map((caw) => ({
        label: caw.name,
        value: caw.id,
      }));
      setSupplierData(cd);
    });
  };

  const styles = {
    menu: (baseStyles) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  useEffect(() => {
    getSuppliers();
    getSizeData();
  }, []);

  useEffect(() => {
    if (supplierId || sizeId) {
      getProducts();
    } else {
      setProductData([]);
    }
  }, [supplierId, sizeId]);

  const printStock = () => {
    setTimeout(() => {
      window.print();
    }, 300);
  };

  return (
    <>
      <div className="row">
        <div className="col-2 hidden-print">
          <h1>
            View Stocks
          </h1>
        </div>
        <div className="col-10 hidden-print">
          <div className="d-flex align-items-center justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
                <Select
                    placeholder="Select Supplier"
                    className="form-control-sm"
                    style={{ border: "1px solid lightgray" }}
                    options={supplierData}
                    isClearable
                    value={supplierId}
                    styles={styles}
                    onChange={(e) => {
                      setSupplierId(e);
                    }}
                />
            </div>
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <Select
                placeholder="Select Size"
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                options={sizeData}
                isClearable
                value={sizeId}
                styles={styles}
                onChange={(e) => {
                  setSizeId(e);
                }}
              />
            </div>
            <button className="btn btn-primary" onClick={() => printStock()}>
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Print Stock
            </button>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card" id="view-stock">
            <div className="card-body p-0">
              {loading && <Loader />}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th width="100">Image</th>
                        <th>Name</th>
                        <th>In Stock</th>
                        <th>Size</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productData.map((row, key) => (
                        <tr key={key}>
                          <td className="table-avatar">
                            <div
                              style={{
                                backgroundImage: "url(" + row.image + ")",
                                height: 50,
                                width: 50,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                              }}
                            ></div>
                          </td>
                          <td>{row.name}</td>
                          <td style={{ fontSize: "18px" }}><strong>{row.in_stock}</strong></td>
                          <td>{row.size_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewStock;
